module.exports = __webpack_public_path__ + "static/media/icon_nav_on_project.c6743734.svg";